import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "@axios";
import { Balance } from "@models/balance";
import { translate } from "@components/i18n";
import { RootState } from "@redux/reducers";
import { addNotification } from "../notification";
import balance from ".";

export const fetchBalance = createAsyncThunk<Balance.Response, Balance.Params>(
  'balances',
  async (request, thunkAPI) => {
    try {
      const response = await axios.get<Balance.ResponseApi>(
        `/integracao/saldo-liga/${request.codigoCliente}/divisao/${request.divisao}`
      );

      const { data, status } = response;

      if (status === 200) {
        const result = Object.assign(new Balance.ResponseApi(), data)
        return result.fromJSON()
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      console.error(e);
      
          let message = ''
          if(e?.response?.data && e.response.data.length > 0 && e.response.data[0].msgUsuario){
              message = e.response.data[0].msgUsuario;
          }else{
              message = translate('general.error');
          }
          
          thunkAPI.dispatch(
              addNotification({
                  type: 'error',
                  message: message,
                  title: translate('general.errorT'),
              }),
          );
      return thunkAPI.rejectWithValue(message);
    }
  },
);

interface IBalanceState {
  isFetching: boolean;
  isSuccess: boolean;
  isError: boolean;
  errorMessage?: string;

  useBalance?: boolean
  balance?: Balance.Response
}

const initialState: IBalanceState = {
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};


const balanceSlice = createSlice({
    name: 'balanceSlice',
    initialState,
    reducers: {
      clearStateBalance: (state) => {
        state = { ...initialState };

        return state;
      },
      updateUseBalance: (state, {payload}: PayloadAction<boolean>) => {
        state.useBalance = payload

        return state;
      }
    },
    extraReducers: {
      [fetchBalance.pending.toString()]: (state) => {
        state.isFetching = true;
        state.isSuccess = false;
        state.balance = undefined
        state.isError = false;
        return state;
      },
      [fetchBalance.fulfilled.toString()]: (
        state,
        { payload }: PayloadAction<Balance.Response>,
      ) => {
        state.isFetching = false;
        state.isSuccess = true;
        state.balance = payload
        state.isError = false;
        return state;
      },
      [fetchBalance.rejected.toString()]: (state, { payload }: PayloadAction<string>,) => {
        state.isFetching = false;
        state.isSuccess = false;
        state.balance = undefined;
        state.isError = true
        state.errorMessage = payload
        return state;
      },
    },
});

export const balanceSelector = (state: RootState): IBalanceState =>  state.balance;


export const {
  clearStateBalance,
  updateUseBalance
} = balanceSlice.actions

export default balanceSlice.reducer;